export const supportedCurrentAndDepositAccountCurrencies = `
<p>
The following table provides a list of the currencies that Gem Connect client current and deposit accounts may be held in.
</p>
<p>The set of currencies available to clients when they create the accounts themselves – via Gem Connect Account management via Import accounts or Add account – is a subset of these, as indicated.</p>
<p>If a current/deposit account is required in a non-self-serve currency, please contact the Onboarding and Servicing team who can create the account for you.</p>
<p>There are an additional six currencies are available for payment creation only, these are listed at the foot of the page.</p>
<table class='table table-bordered table-striped floatedTable'>
<thead>
<tr>
<td>Code</td><td>Currency</td><td>Currency available via client self-serve account creation?</td>
</tr>
</thead>
<tbody>
<tr><td>AED</td><td>United Arab Emirates dirham</td><td>N</td></tr>
<tr><td>AUD</td><td>Australian dollar</td><td>Y</td></tr>

<tr><td>BHD</td><td>Bahraini dinar</td><td>N</td></tr>
<tr><td>CAD</td><td>Canadian dollar</td><td>Y</td></tr>

<tr><td>CHF</td><td>Swiss franc</td><td>Y</td></tr>
<tr><td>CNY</td><td>Chinese renminbi</td><td>N</td></tr>
<tr><td>CZK</td><td>Czech koruna</td><td>N</td></tr>
<tr><td>DKK</td><td>Danish krone</td><td>Y</td></tr>
<tr><td>EUR</td><td>Euro </td><td>Y</td></tr>

<tr><td>GBP</td><td>Great British pounds</td><td>Y</td></tr>
<tr><td>HKD</td><td>Hong Kong dollar</td><td>N</td></tr>
<tr><td>HUF</td><td>Hungarian forint</td><td>N</td></tr>
<tr><td>ILS</td><td>Israeli shekel</td><td>N</td></tr>
<tr><td>INR</td><td>Indian rupee</td><td>N</td></tr>
<tr><td>JOD</td><td>Jordanian dinar</td><td>N</td></tr>
<tr><td>JPY</td><td>Japanese yen</td><td>Y</td></tr>

<tr><td>KWD</td><td>Kuwaiti dinar</td><td>N</td></tr>
<tr><td>MAD</td><td>Moroccan dirham</td><td>N</td></tr>

<tr><td>MXN</td><td>Mexican peso</td><td>N</td></tr>
<tr><td>NOK</td><td>Norwegian krone</td><td>Y</td></tr>
<tr><td>NZD</td><td>New Zealand dollar</td><td>Y</td></tr>
<tr><td>OMR</td><td>Omani rial</td><td>N</td></tr>
<tr><td>PLN</td><td>Polish zloty</td><td>N</td></tr>
<tr><td>QAR</td><td>Qatari riyal</td><td>N</td></tr>
<tr><td>RON</td><td>Romanian leu</td><td>N</td></tr>
<tr><td>SAR</td><td>Saudi Arabian riyal</td><td>N</td></tr>
<tr><td>SEK</td><td>Swedish krone</td><td>Y</td></tr>
<tr><td>SGD</td><td>Singapore dollar</td><td>N</td></tr>
<tr><td>THB</td><td>Thai baht</td><td>N</td></tr>
<tr><td>TND</td><td>Tunisian dinar</td><td>N</td></tr>
<tr><td>TRY</td><td>Turkish lira</td><td>N</td></tr>

<tr><td>USD</td><td>United States of America dollar</td><td>Y</td></tr>

<tr><td>ZAR</td><td>South African rand</td><td>N</td></tr>
</tbody>
</table>
<p>Payment Only Currencies</p>
<table class='table table-bordered table-striped floatedTable'>
<thead>
<tr>
<td>Code</td><td>Currency</td><td>PaymentExecutionOnly</td>
</tr>
</thead>
<tbody>
<tr><td>BBD</td><td>Barbados Dollar</td><td>Yes</td></tr>
<tr><td>KES</td><td>Kenyan Shilling</td><td>Yes</td></tr>
<tr><td>MUR</td><td>Mauritius Rupee</td><td>Yes</td></tr>
<tr><td>TTD</td><td>Trinidad & Tobago Dollar</td><td>Yes</td></tr>
<tr><td>TZS</td><td>Tanzanian Shilling</td><td>Yes</td></tr>
<tr><td>XCD</td><td>East Caribbean Dollar</td><td>Yes</td></tr>
</tbody>
</table>`;


// WEBPACK FOOTER //
// ./src/components/content/appendices/4-supportedCurrentAndDepositAccountCurrencies.ts